export type SubjectId = 'matematik' | 'fysik' | 'kemi' | 'biologi';

export interface SubjectPresentation {
  id: SubjectId;
  label: string;
  route: string;
  icon: 'calculator' | 'atom' | 'flask-conical' | 'brain';
  heroTitle: string;
  composerPlaceholder: string;
  examplePrompts: string[];
}

export const SUBJECTS: SubjectPresentation[] = [
  {
    id: 'matematik',
    label: 'Matematik',
    route: '/matematik',
    icon: 'calculator',
    heroTitle: 'Hvad skal du have hjælp med i matematik?',
    composerPlaceholder: 'Spørg om matematik...',
    examplePrompts: [
      'Jeg er lige startet i 1. g på gymnasiet. Hvad er en lineær funktion?',
      'Kan du forklare kædereglen i differentialregning?',
      'Hvordan løser jeg en andengradsligning?',
    ],
  },
  {
    id: 'fysik',
    label: 'Fysik',
    route: '/fysik',
    icon: 'atom',
    heroTitle: 'Hvad skal du have hjælp med i fysik?',
    composerPlaceholder: 'Spørg om fysik...',
    examplePrompts: [
      'Hvad er Newtons anden lov?',
      'Kan du forklare impuls og momentum?',
      'Hvordan beregner jeg acceleration?',
    ],
  },
  {
    id: 'kemi',
    label: 'Kemi',
    route: '/kemi',
    icon: 'flask-conical',
    heroTitle: 'Hvad skal du have hjælp med i kemi?',
    composerPlaceholder: 'Spørg om kemi...',
    examplePrompts: [
      'Hvad er mol og Avogadros konstant?',
      'Kan du forklare pH og surhed?',
      'Hvordan balancerer jeg en kemisk ligning?',
    ],
  },
  {
    id: 'biologi',
    label: 'Biologi',
    route: '/biologi',
    icon: 'brain',
    heroTitle: 'Hvad skal du have hjælp med i biologi?',
    composerPlaceholder: 'Spørg om biologi...',
    examplePrompts: [
      'Hvad er forskellen på mitose og meiose?',
      'Kan du forklare fotosyntese?',
      'Hvordan fungerer DNA-replikation?',
    ],
  },
];

export function getSubjectByRoute(pathname: string): SubjectPresentation | undefined {
  return SUBJECTS.find((subject) => subject.route === pathname);
}

export function getSubjectById(id: SubjectId): SubjectPresentation {
  const subject = SUBJECTS.find((s) => s.id === id);
  if (!subject) {
    throw new Error(`Unknown subject: ${id}`);
  }
  return subject;
}
